import React, { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Empty } from 'antd';

import ReportsContext from '@totem/components/reports/ReportsContext';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import authUtilities from '@totem/utilities/authUtilities';
import { isNotNull } from '@totem/utilities/common';

const ReportsPanel = () => {
  const { userProfile } = useContext(UserProfileContext);
  const navigate = useNavigate();
  const { reports } = useContext(ReportsContext);

  const hasReports = isNotNull(reports) && reports.length > 0;

  if (hasReports && reports.length === 1) {
    navigate(reports[0].link);
  }

  const endpoint = authUtilities.isTenantUser(userProfile)
    ? '/tenant-dashboard'
    : authUtilities.isVendorUser(userProfile)
      ? '/vendor-dashboard'
      : '/dashboard';

  return (
    <>
      {hasReports && (
        <ul>
          {reports.map((report) => {
            return (
              <li key={report.id}>
                <NavLink to={`${endpoint}/${report.link}`}>
                  {report.name}
                </NavLink>
              </li>
            );
          })}
        </ul>
      )}
      {!hasReports && <Empty />}
    </>
  );
};

export default ReportsPanel;
